import { createActionGroup, props } from '@ngrx/store';
import { Media } from '@pixacare/domain';
import { ClientData } from '../../models/base/client-data';
import { CLIENTS_FEATURE_KEY } from './clients.selectors';

export const clientsActions = createActionGroup({
  source: CLIENTS_FEATURE_KEY,
  events: {
    'Update clients': props<{ clients: ClientData[] }>(),
    'Update data consumption': props<{ clientCode: string; medias: Media[] }>(),
  },
});
